import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/EngagementCampaignInfluencerDaily.graphql';
import { Query, QueryengagementCampaignReportArgs } from '../../__generated__/globalTypes';

export const useEngagementCampaignInfluencerDailyQuery = (
  options?: QueryHookOptions<Query, QueryengagementCampaignReportArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryengagementCampaignReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useEngagementCampaignInfluencerDailyLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryengagementCampaignReportArgs>
): QueryResult<Query, QueryengagementCampaignReportArgs> & {
  getEngagementCampaignInfluencerDaily: LazyQueryExecFunction<Query, QueryengagementCampaignReportArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getEngagementCampaignInfluencerDaily, result] = useLazyQuery<Query, QueryengagementCampaignReportArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getEngagementCampaignInfluencerDaily, ...result };
};

export const useEngagementCampaignInfluencerDailyPromiseQuery = () => {
  const client = useApolloClient();

  const getEngagementCampaignInfluencerDaily = useCallback(
    (options?: Omit<QueryOptions<QueryengagementCampaignReportArgs, Query>, 'query'>) =>
      client.query<Query, QueryengagementCampaignReportArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getEngagementCampaignInfluencerDaily };
};
// Suspense Query Hooks
export const useEngagementCampaignInfluencerDailySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryengagementCampaignReportArgs>
) => {
  const result = useSuspenseQuery<Query, QueryengagementCampaignReportArgs>(QUERY, {
    ...options
  });

  return result;
};
